import { render } from "./crossChain_1.vue?vue&type=template&id=acb47258&scoped=true&lang=pug"
import script from "./crossChain_1.vue?vue&type=script&setup=true&lang=js"
export * from "./crossChain_1.vue?vue&type=script&setup=true&lang=js"

import "./crossChain_1.vue?vue&type=style&index=0&id=acb47258&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb47258"]])

export default __exports__